import { Outlet } from 'react-router-dom';

import Meta from '../../components/Meta';
import Header from '../../components/Header';
import WalletList from '../../wallet/WalletList';
import WalletCheckout from '../../wallet/WalletCheckout';

function Template() {
	return (
		<>
			<Meta title="Wallet" />
			<Header heading={"Wallet"} />
			<main>
				<Outlet />
			</main>
		</>
	);
}

export default {
	Template,
	List: function WalletDashboardList() {
		return <WalletList basePath="/dashboard/wallet" />;
	},
	Checkout: function WalletDashboardCheckout() {
		return <WalletCheckout basePath="/dashboard/wallet" />;
	}
};
